module.exports = __webpack_public_path__ + "static/Cooler Future-37f6b12df35b494f6f45a58907d1afc1.jpg";